// extracted by mini-css-extract-plugin
export default {"plus":"styles_plus__7bSTZ"};